/**
 * Returns true if the subject is a string
 * @param subject
 */
export default function isString(subject) {
    return typeof subject === 'string';
}
